<app-layout pageTitle="Page Not Found!" [verticallyCentered]="true" subtitle="(404)">
  <div class="text-center">
    <a routerLink mat-fab extended color="primary">
      <mat-icon>home</mat-icon>
      <span>Back to home</span>
    </a>
  </div>
</app-layout>
